import { isObject } from 'lodash';
import {
  BubbleChartEmptyStateData,
  BubbleChartSelectedFieldInfo,
} from './types';

const BUBBLE_CHART_EMPTY_STATE_DATA_KEYS: (keyof BubbleChartEmptyStateData)[] =
  [
    'isViewEmpty',
    'selectedComponentHasNumericFields',
    'hasActiveFilter',
    'allDescendantsIncluded',
    'hasFieldsSelected',
    'isPresentationMode',
    'noNumericFields',
    `isWorkspaceEmpty`,
  ];

export const isBubbleChartEmptyStateData = (
  data: Record<string, unknown>
): data is BubbleChartEmptyStateData =>
  BUBBLE_CHART_EMPTY_STATE_DATA_KEYS.every(key => key in data);

export const isBubbleChartFieldInfo = (
  maybeBubbleChartFieldInfo: unknown
): maybeBubbleChartFieldInfo is BubbleChartSelectedFieldInfo =>
  isObject(maybeBubbleChartFieldInfo) &&
  'fieldName' in maybeBubbleChartFieldInfo &&
  'type' in maybeBubbleChartFieldInfo;

export const isBubbleChartStringField = (
  field: string | BubbleChartSelectedFieldInfo | null
): field is string => typeof field === 'string';
